import React from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';

import classNames from 'classnames';
import { SlDataService } from '../../services/sl-data.service';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { Container } from '../../../../symphony';
import { SlEventsService } from '../../services/Business/sl-events.service';

import s from './Footer.scss';
import { RunButton } from '../../../../shared/public/SlCodeEditorComponents/RunButton/RunButton';
import { lePlaygroundContext } from '../../global-constants';

export const Footer: React.FC = React.memo(() => {
	useStyles(s);

	const {
		isDarkMode$: isDarkMode,
	} = useContainerData(
		lePlaygroundContext.value,
		SlDataService,
		['isDarkMode$'],
	);

	const eventService = Container.take(lePlaygroundContext.value, SlEventsService);

	const handleRunBtnClick = (): void => {
		eventService.onHeaderCompileCode();
	};

	return (
		<div
			className={classNames('sl-playground-footer-wrapper', {
				dark: isDarkMode,
			})}
		>
			<RunButton className="sl-playground-footer-wrapper__button" onClick={handleRunBtnClick} />
		</div>
	);
});
